{
  "accent": "Accent",
  "width": "Width",
  "showCovers": "Show covers",
  "showTrackNumber": "Show track number",
  "showFileExtension": "Show file extension",
  "trackInfoAlign": "Track info align",
  "trackInfoAlignLeft": "left",
  "trackInfoAlignRight": "right"
}
